import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';
import { format } from 'date-fns';

import { useCustomerDetailsContext } from '@/modules/customers/customer-details/context';
import { formatCurrencyInBDT } from '@/utils';

export const CustomerSummary = () => {
    const { data } = useCustomerDetailsContext();

    const totalOrders = data?.total_orders ?? 0;
    const averageOrderValue = data?.average_order_value ?? 0;
    const lastOrderDate = data?.last_order_date
        ? format(new Date(data.last_order_date), 'PPP')
        : 'N/A';

    return (
        <Card>
            <CardHeader className="p-4 sm:p-6">
                <CardTitle>Customer Summary</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 p-4 pt-0 sm:p-6 sm:pt-0">
                <div className="flex flex-col items-start gap-1 rounded-md border border-gray-500 bg-gray-50 px-4 py-2.5 sm:flex-row sm:items-center sm:justify-between">
                    <span>Total Orders</span>
                    <span className="break-words font-bold">{totalOrders}</span>
                </div>

                <div className="flex flex-col items-start gap-1 rounded-md border border-gray-500 bg-gray-50 px-4 py-2.5 sm:flex-row sm:items-center sm:justify-between">
                    <span>Average Spending</span>
                    <span className="break-words font-bold">
                        {formatCurrencyInBDT(averageOrderValue)}
                    </span>
                </div>

                <div className="flex flex-col items-start gap-1 rounded-md border border-gray-500 bg-gray-50 px-4 py-2.5 sm:flex-row sm:items-center sm:justify-between">
                    <span>Last Purchase</span>
                    <span className="break-words font-bold">
                        {lastOrderDate}
                    </span>
                </div>
            </CardContent>
        </Card>
    );
};

CustomerSummary.displayName = 'CustomerSummary';
